
<template>
  <div class="help-desk-area pt-100 pb-75">
    <div class="container">
      <div class="section-title">
        <span class="sub-title">Como Podemos Ajudar</span>
        <h2>Estamos ajudando equipes a fazer seu melhor trabalho</h2>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1200">
          <div class="single-help-desk-box">
            <div class="icon">
              <img src="../../assets/images/icon/icon1.png" alt="icon">
            </div>
            <h3>Configuração Zero</h3>
            <p>Implementamos soluções prontas para uso, com configuração automatizada que permite que você foque no seu negócio desde o primeiro dia.</p>
<!--            <router-link to="/services-details" class="link-btn">Saiba Mais <i class="ph-caret-right"></i></router-link>-->
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
          <div class="single-help-desk-box">
            <div class="icon">
              <img src="../../assets/images/icon/icon2.png" alt="icon">
            </div>
            <h3>Segurança do Código</h3>
            <p>Desenvolvemos com as melhores práticas de segurança, protegendo seus dados e garantindo a integridade de suas informações.</p>
<!--            <router-link to="/services-details" class="link-btn">Saiba Mais <i class="ph-caret-right"></i></router-link>-->
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
          <div class="single-help-desk-box">
            <div class="icon">
              <img src="../../assets/images/icon/icon3.png" alt="icon">
            </div>
            <h3>Gestão de Equipe</h3>
            <p>Criamos ferramentas que facilitam o gerenciamento de equipes, melhorando a produtividade e colaboração no seu negócio.</p>
<!--            <router-link to="/services-details" class="link-btn">Saiba Mais <i class="ph-caret-right"></i></router-link>-->
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="300">
          <div class="single-help-desk-box">
            <div class="icon">
              <img src="../../assets/images/icon/icon4.png" alt="icon">
            </div>
            <h3>Controle de Acesso</h3>
            <p>Implementamos sistemas seguros com níveis de permissão personalizados para proteger informações sensíveis da sua empresa.</p>
<!--            <router-link to="/services-details" class="link-btn">Saiba Mais <i class="ph-caret-right"></i></router-link>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HowCanHelp'
}
</script>